import { Flex, Grid, Text, VStack } from '@chakra-ui/react'
import dateFormat from 'functions/dateFormat'
import React from 'react'

interface Props {
    created_at: string
    glucose_value: string
    date: string
    time: string
    status: string
    gestational_age: string
    weight: String
    observation: string
}

const GlucoseValues = ({ created_at, glucose_value, date, time, status, gestational_age, weight, observation}: Props) => {
    return (
        <Flex w="full" flexDirection="column">
            <Text mb="2">Data do registro: {dateFormat(created_at, "dd/MM/yyyy HH:mm:ss")}</Text>
            <Text fontWeight="bold">Valor da Glicemia (mg/dL): {glucose_value}</Text>
            <Text fontWeight="bold">Data e hora: {date} {time}</Text>
            <Text fontWeight="bold">Situação: {status}</Text>
            <Text fontWeight="bold">Idade Gestacional atualizada (em semanas): {gestational_age}</Text>
            <Text fontWeight="bold">Peso (em kg): {weight}</Text>
            <Text fontWeight="bold">Observação: {observation}</Text>
        </Flex>
    )
}

export default GlucoseValues